setTimeout(function (){
    $(".js-featured-review").on('click', function() {
        const sectionId = $(this).attr('data-section-id')
        if($(`#${sectionId}`).length > 0){
            $([document.documentElement, document.body]).animate({
                scrollTop: $(`#${sectionId}`).offset().top - 150
            }, 2000);
        }
    });
},500)

$(document).on("click", ".js-product-fixed-button-toggle", function() {
    $(this).closest('.product-item').find('.product-fixed-block').addClass('active');
    $('body').addClass('no-scroll');
});
$(document).on("click", ".product-fixed-block .overflow", function () {
    $(this).closest('.card-action').find('.product-fixed-block').removeClass('active');
    $('body').removeClass('no-scroll');
});
$(document).on("click", ".product-fixed-block form .button", function() {
    $(this).closest('.card-action').find('.product-fixed-block').removeClass('active');
    $('body').removeClass('no-scroll');
});